import React from 'react';

import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { form1PostalCodeValidation } from '../../store/forms/landing-page-actions';

import Button from '../commons/Button';
import LandingPageBrandsSlider from '../LandingPageBrandsSlider';

import { FORM1_VALIDATION_SCHEMA } from '../../constants/validation-schemas';

const LandingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const landingPageState = useSelector((state) => state.landingPage);
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);

  const submitHandler = (values, setFieldError) => {
    dispatch(form1PostalCodeValidation(
      values.postalCode,
      setFieldError,
      currentStep,
      navigate,
    ));
  };

  return (
    <div className="landing-page">
      <div className="welcome-panel">
        <div className="text">
          <h2 className="title">¡Esta navidad tu seguro tiene regalo! Contrata con 45% de descuento.</h2>
          <p>Contrátalo al mejor precio</p>
          <Formik
            onSubmit={(values, { setFieldError }) => submitHandler(values, setFieldError)}
            initialValues={landingPageState}
            validateOnMount
            validateOnChange
            validationSchema={Yup.object().shape(FORM1_VALIDATION_SCHEMA)}>
            {({ errors, isValid, touched }) => {
              return (
                <Form>
                  <div className="form-fields">
                    {errors.postalCode && touched.postalCode && <div className="field-invalid">{errors.postalCode}</div>}
                    <Field name="postalCode" type="text" placeholder="Ingresa tu código postal" maxLength="5" />
                  </div>
                  <div className="form-buttons">
                    <Button
                      type="submit"
                      disabled={!isValid}
                      label="Cotizar"
                      buttonClasses="-landing-primary"
                      iconPosition="after"
                      iconClasses="arrow-right" />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="image" />
      </div>

      <div className="why-panel text-center">
        <h2>¿Por qué contratar con General de Seguros?</h2>

        <div className="badges">
          <div className="badge">
            <div className="icon">
              <i className="experience" />
            </div>
            <p className="description">
              Más de
              <br />
              <span>50 años</span>
              <br />
              de experiencia
            </p>
          </div>
          <div className="badge">
            <div className="icon">
              <i className="clients" />
            </div>
            <p className="description">
              <span>+350,000</span>
              <br />
              clientes en
              <br />
              todo México
            </p>
          </div>

          <div className="badge">
            <div className="icon">
              <i className="ranking" />
            </div>
            <p className="description">
              Somos el
              <br />
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              <span>1<sup>er</sup> lugar</span> <br />
              en CONDUSEF
            </p>
          </div>
        </div>

        <h2>Algunos de nuestros clientes</h2>
        <p>Algunas de las empresas que confían en nosotros para asegurar sus vehículos:</p>

        <LandingPageBrandsSlider />

        <div className="features text-left">
          <div className="feature">
            <i className="icon -price" />
            <div className="description">
              <h3>El mejor precio</h3>
              <p>Con General de Seguros ahorras más.</p>
            </div>
          </div>
          <div className="feature">
            <i className="icon -online" />
            <div className="description">
              <h3>100% en línea</h3>
              <p>Asegura tu auto en 2 minutos y recibe tu póliza inmediatamente.</p>
            </div>
          </div>
          <div className="feature">
            <i className="icon -cover" />
            <div className="description">
              <h3>Con la mejor cobertura</h3>
              <p>Te estarás protegiendo con la aseguradora 1º ante CONDUSEF.</p>
            </div>
          </div>
        </div>

        <div className="bottom-panel">
          <h2>Asegura hoy tu auto. ¡Cotiza ahora!</h2>
          <Formik
            onSubmit={(values, { setFieldError }) => submitHandler(values, setFieldError)}
            initialValues={landingPageState}
            validateOnMount
            validateOnChange
            validationSchema={Yup.object().shape(FORM1_VALIDATION_SCHEMA)}>
            {({ errors, isValid, touched }) => {
              return (
                <Form>
                  <div className="form-fields">
                    <p>
                      Ingresa tu código postal&nbsp;
                      <span className="color-red">*</span>
                    </p>
                    {errors.postalCode && touched.postalCode && <div className="field-invalid">{errors.postalCode}</div>}
                    <Field name="postalCode" type="text" maxLength="5" />
                  </div>
                  <div className="form-buttons">
                    <Button
                      type="submit"
                      disabled={!isValid}
                      label="Cotizar"
                      buttonClasses="-landing-secondary"
                      iconPosition="after"
                      iconClasses="arrow-right" />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
